<div class="report-page-root-container  weekly-report-component-container  ">
  <div class="page-content">
    <div class="page-header">
      <img class="icon" src="assets/images/menu/svg/day-end-report.svg" width="27">
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon"
            [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
          <span class="action-btn-title">Export</span>
        </button>
        }
        <!-- <button mat-flat-button class="action-btn btn-save" (click)="navigateToWeeklyReport()">View</button> -->
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row">
              <mat-form-field>
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="pickerFrom" formControlName="period_from" placeholder="DD-MM-YYYY"
                  required>
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_from')?.hasError('required') && editForm.get('period_from')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field>
            </div>
            <div class="input-group" style="display: none;">
              <mat-form-field class="example-full-width">
                <mat-label>Shift</mat-label>
                <input matInput value="Daily shift" formControlName="shift_from">
              </mat-form-field>
            </div>

            <div class="list-row terminals">
              <div class="header" (click)="isExpandedTerminal = !isExpandedTerminal">
                <div class="title-container">
                  <span class="title">Terminal</span> <span class="count" *ngIf="selectedTerminalSourcesCount>0">[
                    {{selectedTerminalSourcesCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedTerminal">
                    <button type="button" class="list-action-button" mat-icon-button
                      (click)="$event.stopPropagation(); showSelectedTerminalOnly = !showSelectedTerminalOnly"
                      [matTooltip]="showSelectedTerminalOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedTerminalOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button" mat-icon-button
                      (click)="$event.stopPropagation(); toggleSelectAllTerminal()" matTooltip="Select All/None">
                      <mat-icon>{{ getSelectAllIconTerminal() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button"
                    (click)="$event.stopPropagation(); isExpandedTerminal = !isExpandedTerminal">
                    <mat-icon>{{ isExpandedTerminal ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedTerminal" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Terminal" formControlName="terminalFilter">
                      <button *ngIf="editForm.get('terminalFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('terminalFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredTerminalListData">
                      <div class="list-item"
                        (click)="item.selected = !item.selected; onListSelectionChange('terminal')">
                        <div class="name"><span>{{item.item.name}}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected"
                            (change)="item.selected = !item.selected; onListSelectionChange('terminal')"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>